import { defaultObj } from './state'
import isEmpty from '../../utility/isEmpty'

export default {
  setPaymentData (state, paymentData) {
    state.paymentSession = true

    if (paymentData.brand) {
      state.brand = paymentData.brand
    }
    if (paymentData.paymentCardIds !== undefined) { // cardId will be set to null when making a $0 refi payment (service will submit it as cash payment)
      state.paymentCardIds = paymentData.paymentCardIds
    }
    if (paymentData.cardHolderName) {
      state.cardHolderName = paymentData.cardHolderName
    }
    if (paymentData.cardNumber) {
      state.cardNumber = paymentData.cardNumber.substring(paymentData.cardNumber.length - 4)
    }
    if (paymentData.cardType) {
      state.cardType = paymentData.cardType
    }
    if (paymentData.guestCard !== undefined) {
      state.guestCard = paymentData.guestCard
    }
    if (paymentData.saveGuestCard !== undefined) {
      state.saveGuestCard = paymentData.saveGuestCard
    }
    if (paymentData.cvv !== undefined) {
      state.cvv = paymentData.cvv
    }
    if (paymentData.expirationMonth !== undefined) {
      state.expirationMonth = paymentData.expirationMonth
    }
    if (paymentData.expirationYear !== undefined) {
      state.expirationYear = paymentData.expirationYear
    }
    if (paymentData.isRefi !== undefined) {
      state.isRefi = paymentData.isRefi
    }
    if (paymentData.loan) {
      state.loan = paymentData.loan
    }
    if (paymentData.paymentAmount !== undefined) {
      state.paymentAmount = paymentData.paymentAmount
    }
    if (paymentData.paymentAmountType) {
      state.paymentAmountType = paymentData.paymentAmountType
    }
    if (paymentData.storePhoneNumber) {
      state.storePhoneNumber = paymentData.storePhoneNumber
    }
    if (paymentData.isAlternatesTurn !== undefined) {
      state.isAlternatesTurn = paymentData.isAlternatesTurn
    }
    if (paymentData.alternateProfileId) {
      state.alternateProfileId = paymentData.alternateProfileId
    }
    if (paymentData.alternateDiscAcknowledge) {
      state.alternateDiscAcknowledge = paymentData.alternateDiscAcknowledge
    }
    if (paymentData.alternateContact) {
      state.alternateContact = paymentData.alternateContact
    }
    if (paymentData.preventRefi !== undefined) {
      state.preventRefi = paymentData.preventRefi
    }
    if (paymentData.paymentType) {
      state.paymentType = paymentData.paymentType
    }
    if (paymentData.disbursementAmount !== undefined) {
      state.disbursementAmount = paymentData.disbursementAmount
    }
    if (paymentData.paymentKey !== undefined) {
      state.paymentKey = paymentData.paymentKey
    }
    if (paymentData.disbursementType !== undefined) {
      state.disbursementType = paymentData.disbursementType
    }
    if (Array.isArray(paymentData.ancillaryProducts)) {
      state.ancillaryProducts = paymentData.ancillaryProducts
    }
    if (paymentData.ancillaryConfirmText !== undefined) {
      state.ancillaryConfirmText = paymentData.ancillaryConfirmText
    }
    if (paymentData.ancillaryRequiredText !== undefined) {
      state.ancillaryRequiredText = paymentData.ancillaryRequiredText
    }
    if (paymentData.ancillaryShowApptLink !== undefined) {
      state.ancillaryShowApptLink = paymentData.ancillaryShowApptLink
    }
    if (paymentData.migrateProduct !== undefined) {
      state.migrateProduct = paymentData.migrateProduct
    }
    if (paymentData.isEcommProductMigration !== undefined) {
      state.isEcommProductMigration = paymentData.isEcommProductMigration
    }
    if (paymentData.externalNavigation !== undefined) {
      state.externalNavigation = paymentData.externalNavigation
    }
    if (paymentData.isEcommDisburse !== undefined) {
      state.isEcommDisburse = paymentData.isEcommDisburse
    }
    if (paymentData.principleBalance !== undefined) {
      state.principleBalance = paymentData.principleBalance
    }
    if (paymentData.estimatedPayment !== undefined) {
      state.estimatedPayment = paymentData.estimatedPayment
    }
    if (paymentData.guestPayment !== undefined) {
      state.guestPayment = paymentData.guestPayment
    }

    if (paymentData.riskCheck !== undefined) {
      state.riskCheck = paymentData.riskCheck
    }

    if (paymentData.ofrPaymentValue !== undefined) {
      state.ofrPaymentValue = paymentData.ofrPaymentValue
    }

    if (paymentData.pastDueAmount !== undefined) {
      state.pastDueAmount = paymentData.pastDueAmount
    }
  },

  setDisburseCard (state, data) {
    if (data.cardId !== undefined) { // cardId will be set to null when making a $0 refi payment (service will submit it as cash payment)
      state.disburseCardId = data.cardId
    }

    if (data.cardHolderName) {
      state.disburseCardHolderName = data.cardHolderName
    }

    if (data.cardNumber) {
      state.disburseCardNumber = data.cardNumber.length > 4 ? data.cardNumber.substring(data.cardNumber.length - 4) : data.cardNumber
    }

    if (data.cardType) {
      state.disburseCardType = data.cardType
    }
  },

  clearDisburseCard (state) {
    state.disburseCardId = undefined
    state.disburseCardHolderName = ''
    state.disburseCardNumber = ''
    state.disburseCardType = ''
  },

  endPaymentSession (state) {
    state.paymentSession = false
  },

  clearPaymentData (state) {
    const guestCard = state.guestCard
    const saveGuestCard = state.saveGuestCard
    const isAddOnLocked = state.isAddOnLocked
    state = Object.assign(state, defaultObj, { guestCard, saveGuestCard, isAddOnLocked }) // Reset all except guest card and addOnLocked
  },

  resetPaymentAmount (state) {
    state.paymentAmount = defaultObj.paymentAmount
    state.paymentAmountType = defaultObj.paymentAmountType
    state.preventRefi = defaultObj.preventRefi
    state.isRefi = defaultObj.isRefi
  },

  clearPaymentCardData (state) {
    state.paymentCardIds = []
    state.cardHolderName = ''
    state.cardNumber = ''
    state.cardType = ''
    state.cvv = ''
    state.expirationMonth = 0
    state.expirationYear = 0
  },

  setPaymentResult (state, data) {
    state.result = data
  },

  clearPaymentResult (state, data) {
    state.result = null
  },

  paymentPending (state) {
    state.pending = true
  },

  paymentComplete (state) {
    state.pending = false
  },

  hideModalForAlternate (state) {
    state.showAlternateSpousalConsentModal = false
  },

  setNextBusinessDate (state, data) {
    state.nextBusinessDate = data
  },

  setEcommRefi (state, data) {
    if (data.ecommRefiUrl) {
      state.ecommRefiUrl = data.ecommRefiUrl
    }

    if (data.ecommRefiPaymentSucceeded) {
      state.ecommRefiPaymentSucceeded = data.ecommRefiPaymentSucceeded
    }
  },

  setDemoRequirements (state, data) {
    const demoOptions = data.demographicOptions
    if (demoOptions !== undefined) {
      if (demoOptions.race === true ||
          demoOptions.height === true ||
          demoOptions.gender === true ||
          demoOptions.weight === true) {
        state.demographicsNeeded = true
        state.demographicData = data
      } else {
        state.demographicsNeeded = false
      }
    }
  },

  setAutoPay (state, data) {
    if (isEmpty(data)) {
      return
    }

    if (data.enrolled !== undefined) {
      state.autoPay.enrolled = data.enrolled
    }

    // Allowing auto pay props below to be cleared if not enrolling

    if (data.method !== undefined || data.enrolled === false) {
      state.autoPay.method = data.method
    }

    if (data.methodId !== undefined || data.enrolled === false) {
      state.autoPay.methodId = data.methodId
    }

    if (data.methodCardType !== undefined || data.enrolled === false) {
      state.autoPay.methodCardType = data.methodCardType
    }

    if (data.methodDisplayNumber !== undefined || data.enrolled === false) {
      state.autoPay.methodDisplayNumber = data.methodDisplayNumber
    }

    if (data.methodExpirationMonth !== undefined || data.enrolled === false) {
      state.autoPay.methodExpirationMonth = data.methodExpirationMonth
    }

    if (data.methodExpirationYear !== undefined || data.enrolled === false) {
      state.autoPay.methodExpirationYear = data.methodExpirationYear
    }
  },

  completedDemographicsCheck (state) {
    state.demographicsNeeded = false
  },

  setAddOnLock (state, isLocked) {
    state.isAddOnLocked = isLocked
  },

  restoreState (state, data) {
    return new Promise(resolve => { // Best way I could think of to make sure state was restored before I push the route
      resolve(Object.assign(state, data))
    })
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
